<template>
  <div />
</template>

<script setup lang="ts">
import { watch } from 'vue';

import { useAuth, useGtm } from '@/composables';
import {
  GTM_LEGACY_VAR_FREELANCE_JOB,
  GTM_LEGACY_VAR_FREELANCE_PRICE,
  GTM_LEGACY_VAR_VISITOR_ID,
  GTM_LEGACY_VAR_VISITOR_LOCATION,
  GTM_LEGACY_VAR_VISITOR_LOGGING_STATE,
  GTM_LEGACY_VAR_VISITOR_LOGGING_STATE_LOGGED,
  GTM_LEGACY_VAR_VISITOR_LOGGING_STATE_UNLOGGED,
  GTM_LEGACY_VAR_VISITOR_TYPE,
  GTM_LEGACY_VAR_VISITOR_TYPE_CLIENT,
  GTM_LEGACY_VAR_VISITOR_TYPE_FREELANCE,
} from '../plugins/gtm/legacyVars';

const auth = useAuth();
const gtm = useGtm();

watch(() => auth._state.loggedUser, (loggedUser) => {
  if (loggedUser) {
    if (auth.isFreelance) {
      gtm.trackUserVar(GTM_LEGACY_VAR_VISITOR_TYPE, GTM_LEGACY_VAR_VISITOR_TYPE_FREELANCE);
      gtm.trackUserVar(
        GTM_LEGACY_VAR_VISITOR_LOCATION,
        loggedUser.freelance?.geographicAvailability?.address?.city
      );
      gtm.trackFreelanceVar(GTM_LEGACY_VAR_FREELANCE_PRICE, loggedUser.freelance?.price?.target);
      gtm.trackFreelanceVar(GTM_LEGACY_VAR_FREELANCE_JOB, loggedUser.title);
    }

    if (auth.isClient) {
      gtm.trackUserVar(GTM_LEGACY_VAR_VISITOR_TYPE, GTM_LEGACY_VAR_VISITOR_TYPE_CLIENT);
      gtm.trackUserVar(GTM_LEGACY_VAR_VISITOR_LOCATION, loggedUser.company?.address?.city);
    }

    gtm.trackUserVar(GTM_LEGACY_VAR_VISITOR_ID, loggedUser._id);
    gtm.trackUserVar(GTM_LEGACY_VAR_VISITOR_LOGGING_STATE, GTM_LEGACY_VAR_VISITOR_LOGGING_STATE_LOGGED);

    gtm.isSynced();
  } else {
    gtm.trackUserVar(GTM_LEGACY_VAR_VISITOR_LOGGING_STATE, GTM_LEGACY_VAR_VISITOR_LOGGING_STATE_UNLOGGED);
  }
});
</script>

<style>
body #hubspot-messages-iframe-container {
  z-index: calc(2147483647 - 1);
}
</style>
